function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useTranslation } from 'next-i18next';
import * as S from './SeeAll.styles';
export const SeeAll = ({
  text,
  onClick,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(S.Link, _extends({
    onClick: onClick
  }, rest), text || t('b2c.home.seeAll'));
};